/**
 * @generated SignedSource<<1fb7aeb85bc0d61f2d287d0f2e3d6d02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type booksLineDetailPage_Query$variables = {
  code: string;
};
export type booksLineDetailPage_Query$data = {
  readonly booksLineDetail: {
    readonly accountName: string | null | undefined;
    readonly code: string;
    readonly limit: number;
    readonly totalCount: number;
  };
};
export type booksLineDetailPage_Query = {
  response: booksLineDetailPage_Query$data;
  variables: booksLineDetailPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "code",
    "variableName": "code"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limit",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "booksLineDetailPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BooksLineDetail",
        "kind": "LinkedField",
        "name": "booksLineDetail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "booksLineDetailPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BooksLineDetail",
        "kind": "LinkedField",
        "name": "booksLineDetail",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "96397337ea10e35fcd8cfe2c6b6b5ea3",
    "id": null,
    "metadata": {},
    "name": "booksLineDetailPage_Query",
    "operationKind": "query",
    "text": "query booksLineDetailPage_Query(\n  $code: String!\n) {\n  booksLineDetail(code: $code) {\n    code\n    accountName\n    totalCount\n    limit\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "29949dc78e6743a0732f77b15278ebc2";

export default node;
